import React from 'react'
import { useIntl } from 'react-intl'

import { SectionFAQ } from '../../components/SectionFAQ'
import { SectionLastCTA } from '../../components/SectionLastCTA'
import { SlitePage } from '../../components/SlitePage'
import { useRoutes } from '../../routes'
import { getMcpFAQ } from './data'
import { SectionMcpComparison } from './SectionMcpComparison'
import { SectionMcpHero } from './SectionMcpHero'
import { SectionMcpWhySuper } from './SectionMcpWhySuper'

export default function McpPage() {
  const intl = useIntl()
  const routes = useRoutes()

  const pageTitle = intl.formatMessage({
    id: 'mcp.helmet.title',
    defaultMessage: 'Slite MCP — The knowledge base MCP server for AI agents',
  })
  const pageDescription = intl.formatMessage({
    id: 'mcp.helmet.description',
    defaultMessage:
      'The knowledge base MCP for Claude, ChatGPT, and Cursor. Search, write, and organize your company docs — with the permissions you already have.',
  })

  return (
    <SlitePage
      title={pageTitle}
      description={pageDescription}
      canonicalUrl={routes.mcp()}
      background="moon-dust-lighter"
      ogImage="https://cdn.sanity.io/images/dnsgqii5/production/75e263983bbf5ffc8a9c7fcb92b461577faffd47-1200x630.png"
    >
      <SectionMcpHero />
      <SectionMcpWhySuper />
      {/* <SectionMcpVideos /> */}
      <SectionMcpComparison />
      <SectionFAQ faq={getMcpFAQ(intl)} />
      <SectionLastCTA
        background="moon-dust-lighter"
        title={intl.formatMessage({
          id: 'mcp.lastcta.title',
          defaultMessage:
            'Somewhere, an agent is hallucinating your vacation policy',
        })}
        titleMaxWidth={650}
        subtitle={intl.formatMessage({
          id: 'mcp.lastcta.subtitle',
          defaultMessage: 'Give yours the source of truth.',
        })}
      />
    </SlitePage>
  )
}
